import { createMRTColumnHelper, MRT_ColumnDef } from "material-react-table";
import { Team } from "../../types/team";
import {
  publishedIdColumn,
  EntityWithMetadataTableSuffixColumns,
  withFieldProofreadingIndicator,
  createEntityFilterSpec,
} from "./EntityUtils";
import type { FilterSpec } from "../../hooks/useServerFilters";
import { IntellexusDateStructure } from "../../types/intellexusDate";
import EntityReferenceComponent from "../../components/entitiesReferences/EntityReferenceComponent";
import { GetIntellexusDate } from "../../components/forms/common/intellexusDate/IntellexusDateField";

const columnHelper = createMRTColumnHelper<Team>();

const baseTeamColumns: MRT_ColumnDef<Team, any>[] = [
  publishedIdColumn,
  columnHelper.accessor("name", {
    header: "Team Name",
    Cell: ({ cell }) => cell.getValue() || "-",
  }),
  columnHelper.accessor("source_language", {
    header: "Source Language",
    Cell: withFieldProofreadingIndicator("source_language", ({ cell }) =>
      cell.getValue() || "-"
    ),
  }),
  columnHelper.accessor("team_contribution_date", {
    header: "Team Contribution Date",
    filterVariant: "text",
    Cell: withFieldProofreadingIndicator(
      "team_contribution_date",
      ({ cell }) => {
        if (!cell.getValue()) return "-";
        const intellexusDate = cell.getValue() as IntellexusDateStructure;
        return GetIntellexusDate(intellexusDate);
      }
    ),
  }),
];

const tibetanExtraColumns: MRT_ColumnDef<Team, any>[] = [
  columnHelper.accessor("version", {
    header: "Version",
    enableColumnFilter: false,
    Cell: withFieldProofreadingIndicator("version", ({ cell }) => (
      <EntityReferenceComponent entity={cell.getValue()} />
    )),
  }),
  columnHelper.accessor("revision", {
    header: "Revision",
    Cell: withFieldProofreadingIndicator("revision", ({ cell }) =>
      cell.getValue() || "-"
    ),
  }),
];

const chineseExtraColumns: MRT_ColumnDef<Team, any>[] = [
  columnHelper.accessor("title", {
    header: "Title",
    Cell: withFieldProofreadingIndicator("title", ({ cell }) =>
      cell.getValue() || "-"
    ),
  }),
  columnHelper.accessor("taisho_catalog_no", {
    header: "Taisho Catalog Number",
    Cell: withFieldProofreadingIndicator("taisho_catalog_no", ({ cell }) =>
      cell.getValue() || "-"
    ),
  }),
];

const baseTeamSuffixColumns: MRT_ColumnDef<Team, any>[] = [
  columnHelper.accessor("place", {
    header: "Place",
    enableColumnFilter: false,
    Cell: withFieldProofreadingIndicator("place", ({ cell }) => (
      <EntityReferenceComponent entity={cell.getValue()} />
    )),
  }),
  columnHelper.accessor("place_identification_status", {
    header: "Place Identification Status",
    Cell: withFieldProofreadingIndicator(
      "place_identification_status",
      ({ cell }) => cell.getValue() || "-"
    ),
  }),
  ...EntityWithMetadataTableSuffixColumns,
];

export const teamColumns: MRT_ColumnDef<Team, any>[] = [
  ...baseTeamColumns,
  ...baseTeamSuffixColumns,
];

export const tibetanTeamColumns: MRT_ColumnDef<Team, any>[] = [
  ...baseTeamColumns,
  ...tibetanExtraColumns,
  ...baseTeamSuffixColumns,
];

export const chineseTeamColumns: MRT_ColumnDef<Team, any>[] = [
  ...baseTeamColumns,
  ...chineseExtraColumns,
  ...baseTeamSuffixColumns,
];

export const teamFilterSpec: FilterSpec = createEntityFilterSpec({
  name: { kind: "string" },
  source_language: { kind: "string" },
  team_contribution_date: { kind: "string" },
  revision: { kind: "string" },
  title: { kind: "string" },
  taisho_catalog_no: { kind: "string" },
  place_identification_status: { kind: "string" },
});
